import { useEffect, useState } from 'react'
import { MonthlyBars } from '../../components/charts/Bars.jsx'
import { watchFormStats } from '../../lib/formsData.js'
import { formAnalytics } from '../../lib/formsView.js'

const RANGES = [7, 30, 90]

function Tile({ label, value }) {
  return (
    <div style={{ flex: 1, minWidth: 120, background: 'var(--color-panel)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-md)', padding: '14px 16px' }}>
      <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--color-muted)' }}>{label}</div>
      <div className="font-mono" style={{ fontSize: 26, color: 'var(--color-white)', marginTop: 4 }}>{value}</div>
    </div>
  )
}

export default function FormAnalytics({ formId }) {
  const [stats, setStats] = useState([])
  const [range, setRange] = useState(30)
  useEffect(() => watchFormStats(formId, setStats), [formId])
  const a = formAnalytics(stats, range)
  const pct = a.conversion == null ? '—' : `${Math.round(a.conversion * 100)}%`
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {RANGES.map((r) => (
          <button key={r} onClick={() => setRange(r)} className="btn" style={{ fontSize: 12, padding: '6px 12px', background: r === range ? 'var(--color-gold)' : 'transparent', color: r === range ? 'var(--color-ink)' : 'var(--color-muted)', border: '1px solid var(--color-divider-dark)' }}>{r}d</button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
        <Tile label="Unique views (per session)" value={a.views} />
        <Tile label="Submissions" value={a.submissions} />
        <Tile label="Conversion" value={pct} />
        <Tile label="Spam (quarantined)" value={a.spam} />
      </div>
      <p style={{ fontSize: 11, color: 'var(--color-muted)', margin: '4px 0 18px' }}>Conversion = submissions ÷ unique views; quarantined submissions are excluded.</p>
      <div style={{ fontSize: 12, color: 'var(--color-muted)', marginBottom: 8 }}>Submissions per day</div>
      <MonthlyBars data={a.dailyBars} />
    </div>
  )
}
